import { toast } from 'sonner';
import { isDBCreateError } from '@common-reducers/db-create-error';

/**
 * #1136 — the user-facing text for a failed DB create, from whatever a caller caught
 * (`.unwrap()` throws the typed DBCreateError; a wrapper thunk that rethrew it surfaces
 * a SerializedError that keeps `message`).
 */
export const dbCreateErrorMessage = (error: unknown, fallback: string): string => {
  if (isDBCreateError(error) && error.kind === 'network') {
    return `${fallback} Check your connection and try again.`;
  }
  const message = readMessage(error);
  return message && isUserReadable(message) ? `${fallback} ${message}` : fallback;
};

const readMessage = (error: unknown): string | undefined => {
  if (typeof error !== 'object' || error === null || !('message' in error)) return undefined;
  const { message } = error;
  return typeof message === 'string' && message.length > 0 ? message : undefined;
};

// Server business errors ("You have reached your reminders limit") read fine; raw driver
// text (E11000 duplicate key …, Cast to ObjectId failed …) does not, and can echo field values.
const isUserReadable = (message: string): boolean =>
  message.length <= 200 && !/^E\d{5}\b|duplicate key|Cast to|ValidationError|ObjectId/i.test(message);

/** Tells the user a create did not store. `fallback` names what was not saved. */
export const toastDBCreateError = (error: unknown, fallback: string): void => {
  toast.error(dbCreateErrorMessage(error, fallback));
};
